var _rect, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChat(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 33.83,
    height: 33.83,
    fill: "url(#pattern0)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_1033_12249",
    transform: "scale(0.01)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_1033_12249",
    width: 100,
    height: 100,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGQAAABkCAYAAABw4pVUAAAACXBIWXMAAAsTAAALEwEAmpwYAAADu0lEQVR4nO2du2tUQRjFT4KraNZHIfoHiIUg+CjU2Gknxo3EFKaw0lIt7QWNNhY+thUMqey00UqwtLARfCQ24lsb8xA0grsyOMUyzt6db+7c67d7zw+myuSbu+dk7sy5l50AhBBCCCGEENLf1ABMApgF8BLAdwDtirZlq4HR4oTVplTGAcwrEKKttBltGmUYMQzgioIP3O6D1gIwbTUrDJoBsTGXi7xNtZzBfgK4DmA/gBFUlxGrwU0AK56Zciz1gDXPmvEewK7UAw0Au602nVrNpV7oJz0zg2Z0Z49nppjdVzJmneLmNkWyueVoNoOEvHKK70tZfEA54Ghmckoylp3i9ZTFB5S6o9lSbCEmcCRL4O4WWAwTOJIm8GhDmMBRSAKPNoQJHIUk8ChDmMCLS+BiQ5jAi03gYkOYwItN4GJDmMCLTeBiQ5jAi03gYkOYwItN4GJDcifJitIO1I2GlAQNUQYNUQYNUQYNUQYNUQYNUQYNUQYNUQYNUQYNUQYNUQYNUQYNUQYNUQYNUQYNUQYNUQYNUQYNUQYNUQYNUQYNUQYNUQYNUQYNUQYNUQYNUQYNUQYNUQYNUQYN6UNDNjh9FlMVJnG6jQq++iYqTOJ0awq+HCoqTOS67fV8fXoiRWEi182Y8UF4wEBQYRKuW92uGc0uR3CMxRYmcbpltUt5CpMwQoxoWTOG8hQmYfQyY05ym8oqTOJ0MydivLBb24k8Z/QueRYnkk1UAg/FPXzGHNZFsolK4KG4xzPdSFl8QGnGJPBQfAeYmZPTiJ/oBB5KtyP+aMq/5ErgEhqef0OxYg9+HK34Ql9PlcClTAvTZ7f2DsAR4R/Dx0Rjl91ECVzKsDXFnSkx7W3gmGsBfFUgrLRFJfBYGva+mOeCfwWOdUaBuNIWncDzULNHn87Y9Omey9irLQSMMQTgmQKBe7VkCbxMDjsfwuxEenHSc5tbXcK1VoJxR9zXAWvHG+d3zpZ0rZXglCPu0x79rzn95zk70nLBEfhuRt/jnp3c0cTXU3nuOAJfzDgRetHpe7vy6iVmledxwiFPv4N299XZ7zmA9TQkLVOOyGYGrHH6nPM8dvgCYDvNSMtGu13tFPpqx893AHjo2dt/ArCTZqRlHYBHjtCfAWy1z7LuA/jtMcNsd7fRjLQYQZ94xDaz5VtG6r0HYEvia6k8Y5738L2a6X+68soVhORR+YJ9Krq5qIshf993ZJlg1o3HAM4D2ETByrllmVe8P+wibh5HP7C7qym7qBNCCCGEEIL/xx9llZmae2AFHAAAAABJRU5ErkJggg=="
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChat);
export default __webpack_public_path__ + "static/media/chat.f944dee368e839d26b9224eea5687d8b.svg";
export { ForwardRef as ReactComponent };